import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { SpinnerService } from '@services/spinner.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import { IDokumentItemViewModel } from '@shared/dokumente/dokument.model';

interface IFilBez {
    bezeichnung: string;
    id: number;
}

@Component({
    selector: 'cz-file-bezPopup',
    templateUrl: './file-bezPopup.component.html',
    styleUrls: ['./file-bezPopup.component.css'],
    standalone: false
})
export class DocBezeichnungPopupComponent {

    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
    @Output() onOkClose: EventEmitter<any> = new EventEmitter<any>();
    @Input() popupVisible: boolean;
    @Input() selectedDokument: IDokumentItemViewModel;

    context: IFilBez = {} as IFilBez;


    @ViewChild('form', { static: false }) form: DxFormComponent;

    constructor(private spinnerService: SpinnerService, private ajaxService: AjaxService) {
        this.onClickUebernehmen = this.onClickUebernehmen.bind(this);
        this.onClickClose = this.onClickClose.bind(this);
    }

    onClickUebernehmen() {
        if (this.validation()) {

            this.selectedDokument.bezeichnung = this.context.bezeichnung;

            this.ajaxService.post('api/Dokument/SetFileBezeichnung', this.context).subscribe(response => {
                this.onOkClose.emit(true);
                this.popupVisible = false;
            });
        }
    }


    onClickClose() {
        this.popupVisible = false;
    }

    validation(withMsg: boolean = true) {
        const validationResult = this.form.instance.validate();

        if (!validationResult.isValid) {
            if (withMsg) {
                let msg = '';
                for (const err of validationResult.brokenRules) {
                    msg += err.message + '\r\n';
                }

                notify({
                    message: msg,
                    width: 600
                }, 'error', 3000);
            }

            return false;
        }
        else {
            return true;
        }
    }


    onShowingPopup(event) {
        this.context = {
            id: this.selectedDokument.id,
            bezeichnung: this.selectedDokument.bezeichnung
        };
    }

    onHiddenPopup(event) {
        this.context = null;
        this.selectedDokument = null;
        this.onClose.emit(null);
    }

    private startLoading() {
        this.spinnerService.show();
    }

    private stopLoading() {
        this.spinnerService.hide();
    }
}
